import React from 'react';
import './Rfid.css';
import FMSimage from '../Assets/picture rftag.jpg'; // First image (full size)
import FMSimage2 from '../Assets/rfid2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/rfid3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/rfid4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/rfid5.jpg'; // Image for Industries section

const Rfid = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">Active RFID Tag</h1>
                    <p className="FMS-description">
                        The Active RFID Tag from Vajra IoT is a powerful asset-tracking solution powered by an internal battery, enabling long-range signal broadcasting and real-time monitoring. Equipped with a tamper-proof switch and battery voltage level detection, it ensures secure and reliable tracking for assets across various industries, including logistics, healthcare, and industrial automation.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Active RFID Tag" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Active RFID Tag offers advanced features for robust asset management:
                        <ul>
                            <li><strong>Internal Power Source:</strong> Built-in battery enables long-range signal transmission for reliable tracking.</li>
                            <li><strong>Tamper-Proof Switch:</strong> Detects and alerts if the tag is detached from the asset, enhancing security.</li>
                            <li><strong>Battery Voltage Monitoring:</strong> Transmits battery level data to ensure timely replacement and uninterrupted operation.</li>
                            <li><strong>Real-Time Tracking:</strong> Provides continuous location updates for efficient asset management.</li>
                            <li><strong>Data Security:</strong> Ensures encrypted communication to protect sensitive tracking information.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Key Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        The Active RFID Tag operates using its internal battery to power integrated circuits and broadcast signals to RFID readers. Key processes include:
                        <ul>
                            <li><strong>Signal Broadcasting:</strong> Transmits real-time location and status data over long distances.</li>
                            <li><strong>Tamper Detection:</strong> The tamper-proof switch triggers alerts if the tag is removed or tampered with.</li>
                            <li><strong>Battery Monitoring:</strong> Continuously checks and reports battery voltage levels to prevent downtime.</li>
                            <li><strong>Data Transmission:</strong> Securely sends data to a centralized platform for processing and visualization.</li>
                            <li><strong>Dashboard Integration:</strong> Provides an intuitive interface for monitoring assets and receiving alerts.</li>
                        </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Active RFID Tag</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Active RFID Tag is designed for precision, security, and ease of use, offering unmatched reliability in asset tracking. Benefits include:
                        <ul>
                            <li>Long-range tracking with robust signal strength</li>
                            <li>Enhanced security with tamper-proof detection</li>
                            <li>Proactive battery management for uninterrupted operation</li>
                            <li>Seamless integration with existing RFID systems</li>
                            <li>Real-time analytics for optimized asset management</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our Active RFID Tag</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using Active RFID Tag" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Active RFID Tag is trusted across various sectors for its reliability and advanced features in asset tracking:
                        <ul>
                            <li>Logistics & Supply Chain</li>
                            <li>Healthcare</li>
                            <li>Industrial Automation</li>
                            <li>Retail & Inventory Management</li>
                            <li>Construction</li>
                            <li>Transportation</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Rfid;